import './FocusSkeleton.scss';

const FocusSkeleton = () => {

  return (
    <div className="focus__section">
      <div className="design__arrow__skeleton">
        <div className="arrow__wrapper__skeleton">
          <div className='arrow__down__skeleton'></div>
        </div>
      </div>
      <div className="focus__section__wrapper__skeleton">
        <div className="focus__marketing__section__item__desc__skeleton">
          <div className="focus__marketing__section__item__desc__quote__skeleton">
            {[...Array(2)].map((_, i) => (
              <div key={i} className="focus__marketing__section__item__desc__quote__title__skeleton"></div>
            ))}
            <div className="focus__marketing__section__item__desc__quote__title__skeleton--primary"></div>
          </div>
          <div className="focus__marketing__section__item__desc__article__skeleton">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="focus__marketing__section__item__desc__article__text__skeleton"></div>
            ))}
            <div className="focus__marketing__section__item__desc__article__text__skeleton--primary"></div>
          </div>
        </div>
        <div className="focus__section__item__perks__skeleton">
          <div className="right__side__focus__services__section__skeleton">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="services__focus__links__item__skeleton">
              <div className="focus__icon__skeleton"></div>
              <div className="focus__link__item__skeleton"></div>
              <div className="focus__link__item__skeleton--primary"></div>
              {[...Array(5)].map((_, i) => (
                <div key={i} className="services__focus__link__text__skeleton"></div>
              ))}
              <div className="services__focus__link__text__skeleton--primary"></div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FocusSkeleton;